import { showBanner } from '../../global-state/banner-slice'
import type { AppDispatch } from '../../lib/types'
import type { InvestmentFeeSummary } from '../../services/types'
import { PLATFORM_FEE, PLATFORM_FEE_CURRENCY } from './constants'

function isFeeSummaryBody(value: unknown): value is InvestmentFeeSummary {
  return (
    typeof value === 'object' &&
    value !== null &&
    'investmentAmount' in value &&
    typeof (value as InvestmentFeeSummary).investmentAmount === 'number'
  )
}

/** Shows a success banner when the API marks dealing charges as waived (e.g. referral promo). */
export function dispatchDealingChargesWaivedBannerIfNeeded(
  dispatch: AppDispatch,
  payload: unknown,
): void {
  if (!isFeeSummaryBody(payload) || !payload.dealingChargesWaived) return
  const code = payload.promotionalReferralCode?.trim()
  const referralPhrase = code ? ` using referral code ${code}` : ''
  dispatch(
    showBanner({
      text: `Yay! Dealing charges ${PLATFORM_FEE_CURRENCY} ${PLATFORM_FEE} waived${referralPhrase}.`,
      variant: 'success-banner',
      duration: 5000,
    }),
  )
}
